module.exports = __webpack_public_path__ + "img/about-me.6e47664d.jpg";